
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.333 3.333v9.334h9.334V8H14v4.667C14 13.4 13.4 14 12.667 14H3.333C2.593 14 2 13.4 2 12.667V3.333C2 2.6 2.593 2 3.333 2H8v1.333H3.333zm6 0V2H14v4.667h-1.333V4.273l-6.554 6.554-.94-.94 6.554-6.554H9.333z","fill":"#585858"}})])
          )
        }
      }
    